import React, { useEffect, useState } from "react";
import Navbar from "@/components/Navbar";
import { api, apiErr } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { CreditCard, CircleCheck, CircleAlert, ExternalLink } from "lucide-react";

export default function StripeConnect() {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = () => api.get("/connect/status").then(r => setStatus(r.data)).catch(e => toast.error(apiErr(e)));
  useEffect(() => { load(); }, []);

  const startOnboarding = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/connect/create-account", { origin_url: window.location.origin });
      window.location.href = data.url;
    } catch (e) { toast.error(apiErr(e)); setLoading(false); }
  };

  const done = status?.charges_enabled && status?.payouts_enabled;

  return (
    <div className="min-h-screen hub-cream">
      <Navbar/>
      <main className="max-w-3xl mx-auto px-6 md:px-10 py-10">
        <div className="hub-pill hub-sand text-[#0B1D3A] mb-3"><CreditCard size={12}/> Cobros automáticos</div>
        <h1 className="font-serif text-5xl text-[#0B1D3A]">Configura tu cuenta de cobros.</h1>
        <p className="text-[#5C6B7D] mt-2 max-w-xl">Conectas una vez con Stripe y recibes cada trabajo directamente en tu IBAN al aprobarlo el cliente.</p>

        <div className="hub-card p-8 mt-8">
          {!status ? <div>Cargando...</div> : (
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                {done ? <CircleCheck className="text-emerald-500"/> : <CircleAlert className="text-amber-500"/>}
                <div className="font-serif text-2xl">{done ? "Todo listo para cobrar" : "Onboarding pendiente"}</div>
              </div>
              <ul className="space-y-2 text-sm">
                <li className="flex items-center gap-2">{status.details_submitted ? <CircleCheck size={16} className="text-emerald-500"/> : <CircleAlert size={16} className="text-amber-500"/>} Datos personales verificados</li>
                <li className="flex items-center gap-2">{status.charges_enabled ? <CircleCheck size={16} className="text-emerald-500"/> : <CircleAlert size={16} className="text-amber-500"/>} Cobros activados</li>
                <li className="flex items-center gap-2">{status.payouts_enabled ? <CircleCheck size={16} className="text-emerald-500"/> : <CircleAlert size={16} className="text-amber-500"/>} IBAN conectado y payouts listos</li>
              </ul>
              <Button onClick={startOnboarding} disabled={loading} className="hub-btn-primary gap-2" data-testid="connect-start-btn">
                <ExternalLink size={14}/> {done ? "Editar datos" : "Empezar onboarding con Stripe"}
              </Button>
              <p className="text-xs text-[#5C6B7D] italic">Modo sandbox. Al publicar la app en producción los cobros pasan a real automáticamente.</p>
            </div>
          )}
        </div>
      </main>
    </div>
  );
}
